export default __webpack_public_path__ + "static/media/Privacy_policy.1ce5e2c4.pdf";